let $editable = null

let format = {};

const setEditable = ($new) => { $editable = $new };
const getEditable = () => $editable;
const clearEditable = () => { $editable = null };

const setFormat = (fmt) => { format = fmt };
const getFormat = () => format;
const clearFormat = () => { format = null };

export default {
    selectedLocationId: null,
    isComponentMoveInProgress: false,

    setEditable,
    getEditable,
    clearEditable,

    setFormat,
    getFormat,
    clearFormat
}
